<template>
  <div id="app">
    <router-view  />

    <div v-if="this.$store.state.loader" class="loader">
        <div class="roller"></div>
    </div>
  </div>
</template>

<script> 

export default {
  name: 'app', 

}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; 
}

.loader{
  position: fixed;
  top: 0;
  bottom: 0;
  left:0;
  right:0;
  background: #0000009c;
  z-index: 99999999999;
}

.roller{
  position:absolute;
  top:0;
  bottom: 0;
  left:0;
  right:0;
  margin:auto;
  width:100px;
  height: 100px;
  border:2px solid transparent;
  border-top:4px solid white;
  border-radius: 50%;
  animation: roll .5s linear infinite;
}

@keyframes roll {
  0%{
    transform: rotate(0deg);
  }
  100%{
    transform: rotate(360deg);
  }
}
</style>
